"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadingPills = exports.StyledHeadingBackButton = exports.StyledHeaderContent = exports.StyledDivider = exports.StyledHeadingTitle = exports.StyledHeaderHelp = exports.StyledSeparator = exports.StyledHeader = exports.StyledSubHeader = exports.StyledHeading = exports.StyledHeadingIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _icon = _interopRequireDefault(require("../icon"));

var _icon2 = _interopRequireDefault(require("../icon/icon.style"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _help = _interopRequireDefault(require("../help"));

var _typography = _interopRequireDefault(require("../typography"));

var _hr = _interopRequireDefault(require("../hr"));

var _link = _interopRequireDefault(require("../link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledHeading = _styledComponents.default.div`
  width: 100%;
  ${_styledSystem.margin}
`;
exports.StyledHeading = StyledHeading;
StyledHeading.defaultProps = {
  theme: _base.default
};
const StyledHeaderContent = _styledComponents.default.div`
  display: inline-flex;
  align-items: flex-end;
`;
exports.StyledHeaderContent = StyledHeaderContent;
const StyledHeader = _styledComponents.default.div`
  ${({
  divider,
  subheader,
  hasBackLink
}) => (0, _styledComponents.css)`
    ${subheader && (0, _styledComponents.css)`
      margin-bottom: 16px;
    `}

    ${divider && (0, _styledComponents.css)`
      margin-bottom: 15px;
    `}

    ${divider && !subheader && (0, _styledComponents.css)`
      margin-bottom: 20px;
    `}

    ${hasBackLink && (0, _styledComponents.css)`
      display: grid;
      grid-template-columns: min-content auto;
    `}
  `}
`;
exports.StyledHeader = StyledHeader;
const StyledHeadingBackButton = (0, _styledComponents.default)(_link.default)`
  margin-right: 5px;
  margin-top: 2px;

  a,
  button {
    margin: 0 1px 0 0;
    text-decoration: none;

    &:focus {
      background-color: transparent;
      outline: 3px solid ${({
  theme
}) => theme.colors.focus};
    }

    ${_icon2.default} {
      margin-right: 0;
    }
  }
`;
exports.StyledHeadingBackButton = StyledHeadingBackButton;
StyledHeadingBackButton.defaultProps = {
  theme: _base.default
};
const StyledHeadingTitle = (0, _styledComponents.default)(_typography.default)`
  line-height: 32px;
  ${({
  withMargin
}) => withMargin ? (0, _styledComponents.css)`
          margin-right: 16px;
        ` : null}
`;
exports.StyledHeadingTitle = StyledHeadingTitle;
const StyledHeadingPills = _styledComponents.default.span`
  line-height: 32px;
  display: inline-block;
  vertical-align: top;
`;
exports.StyledHeadingPills = StyledHeadingPills;
const StyledSubHeader = _styledComponents.default.div`
  margin-top: 5px;
  grid-row: 2;

  ${({
  hasBackLink
}) => hasBackLink && (0, _styledComponents.css)`
      grid-column: 2;
    `}

  ${({
  hasSeparator
}) => hasSeparator && (0, _styledComponents.css)`
      grid-row: 3;
      margin-top: 0px;
    `}
`;
exports.StyledSubHeader = StyledSubHeader;
const StyledHeadingIcon = (0, _styledComponents.default)(_icon.default)`
  color: ${({
  theme
}) => theme.colors.border};
  height: 30px;

  &:before,
  &${_icon2.default}:before {
    font-size: 24px;
  }

  &:hover {
    color: ${({
  theme
}) => theme.icon.focus};
  }
`;
exports.StyledHeadingIcon = StyledHeadingIcon;
StyledHeadingIcon.defaultProps = {
  theme: _base.default
};
const StyledSeparator = _styledComponents.default.hr`
  border-top: 2px solid ${({
  theme
}) => theme.palette.slateTint(80)};
  margin: 10px 0 8px;
  text-align: left;
  width: 50px;
`;
exports.StyledSeparator = StyledSeparator;
const StyledDivider = (0, _styledComponents.default)(_hr.default)`
  margin: 15px 0 20px;
`;
exports.StyledDivider = StyledDivider;
StyledSeparator.defaultProps = {
  theme: _base.default
};
const StyledHeaderHelp = (0, _styledComponents.default)(_help.default)`
  display: inline-block;
  margin-left: -6px;
  margin-right: 16px;
  position: relative;
  top: -4px;
  height: 22px;
`;
exports.StyledHeaderHelp = StyledHeaderHelp;